module.exports = __webpack_public_path__ + "static/media/majors-students-tucson.2d1cf51f.jpg";